import { serverAddr, fileServerAddr } from "../networkConfig";

export default {
  getAllIncidentCategories() {
    return serverAddr.get('/incident/category/?get_all=true');
  }
};